module.exports = __webpack_public_path__ + "img/website.552e2275.png";